var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5304 4.46967C19.8232 4.76256 19.8232 5.23744 19.5304 5.53033L13.0607 12L19.5303 18.4697C19.8232 18.7626 19.8232 19.2374 19.5303 19.5303C19.2374 19.8232 18.7626 19.8232 18.4697 19.5303L12 13.0607L5.53036 19.5303C5.23746 19.8232 4.76259 19.8232 4.4697 19.5303C4.1768 19.2374 4.1768 18.7626 4.4697 18.4697L10.9394 12L4.46967 5.53033C4.17678 5.23744 4.17678 4.76257 4.46967 4.46967C4.76256 4.17678 5.23744 4.17678 5.53033 4.46967L12 10.9394L18.4697 4.46967C18.7626 4.17678 19.2375 4.17678 19.5304 4.46967Z"
  })));
};
export default SvgClose;